import {
  Link,
  Typography,
  boldBodyTypography,
  spacing3,
  OverflowTooltip,
} from '@leaftrade/leaftrade-component-library';
import PropTypes from 'prop-types';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useStorefrontState } from '../../../../hooks/useReduxState';
import {
  QUICK_ORDER_MODAL_PORTAL_ID,
  QUICK_ORDER_PATH,
  QUICK_ORDER_TOOLTIP_Z_INDEX,
} from '../../../constants';

const ProductName = ({ name, productId, selectedVariantId, slug }) => {
  const { hasLimitedAccess, publicMenu, vendor } = useStorefrontState();
  const { isGridView } = vendor.settings;
  const isQuickOrderPage = window.location.pathname.includes(QUICK_ORDER_PATH);
  const quickOrderTooltipProps = isQuickOrderPage
    ? {
        isTooltipActive: true,
        tooltipProps: {
          portalId: QUICK_ORDER_MODAL_PORTAL_ID,
          style: {
            zIndex: QUICK_ORDER_TOOLTIP_Z_INDEX,
          },
        },
      }
    : {};

  return (
    <>
      {publicMenu?.products ? (
        <Typography
          bodyStyle={!isGridView ? boldBodyTypography : null}
          component='h6'
          sx={{
            flexDirection: 'column',
            alignItems: 'flex-start',
            width: '100%',
            marginBottom: spacing3,
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: isGridView ? 2 : 1,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
          testingId='product-name--component--public--typography'
          underline='hover'
        >
          <OverflowTooltip
            maxLineCount={isGridView ? 2 : 1}
            overflowHeightOffset={4}
            checkOverflowDeps={[isGridView, name]}
            tooltipId='tooltip-id-product-name--text'
            sx={{ width: '100%' }}
            {...quickOrderTooltipProps}
          >
            {name}
          </OverflowTooltip>
        </Typography>
      ) : (
        <Link
          bodyStyle={!isGridView ? boldBodyTypography : null}
          component={RouterLink}
          sx={{
            flexDirection: 'column',
            alignItems: 'flex-start',
            width: '100%',
            marginBottom: spacing3,
          }}
          testingId='product-name--component--link'
          to={`/storefront/sellers/${
            hasLimitedAccess ? 'vendor-preview/' : ''
          }${slug}/${productId}?variant=${selectedVariantId}`}
          underline='hover'
          variant='h6'
        >
          <OverflowTooltip
            maxLineCount={isGridView ? 2 : 1}
            overflowHeightOffset={4}
            checkOverflowDeps={[isGridView, name]}
            tooltipId='tooltip-id-product-name--link'
            sx={{ width: '100%' }}
            {...quickOrderTooltipProps}
          >
            {name}
          </OverflowTooltip>
        </Link>
      )}
    </>
  );
};

ProductName.propTypes = {
  name: PropTypes.string.isRequired,
  productId: PropTypes.number.isRequired,
  selectedVariantId: PropTypes.number.isRequired,
  slug: PropTypes.string.isRequired,
};

export default ProductName;
